export const CHORD_PREFIX_KEY = 'g';
export const CHORD_TIMEOUT_MS = 1500;

// Keep in sync with NAV_ITEMS (MainSidebar.constants.ts) and NAV_COMMANDS
// (CommandPalette.constants.ts) — the "G X" hints rendered there map here.
export const GO_TO_ROUTES: Record<string, string> = {
	d: '/',
	m: '/modules',
	c: '/conversations',
	j: '/judges',
	e: '/evaluations',
	r: '/reports',
	p: '/dependencies',
};
